/* newtestdesign · search page (sections/ntd-search.liquid): the stickers for the sheet.
   Shopify's search only knows products; the stickers live in the builder's list (assets/ssb-stickers.json)
   plus the ones the shop adds itself (Content → Metaobjects, in the page as [data-extra-stickers]).
   Same matching as the header's search (NTD.findStickers in ntd.js: every word in the name or the
   section, Arabic words find the English names). Up to 24 tiles, each opening the builder with that
   sticker on the sheet; "See them all in the builder" opens it with the search filled in. */
(function () {
  "use strict";
  var doc = document, root = doc.querySelector("[data-spage]");
  var box = root && root.querySelector("[data-stickers]");
  var q = root ? (root.getAttribute("data-q") || "").trim() : "";
  if (!box || !q || !window.fetch) return;
  var tints = ["#e9f2f6", "#f8f0dc", "#e7f0ea", "#f6e6e3", "#eceefa", "#f6edcf", "#f2e7e2", "#e3efeb"];   // the header's tiles
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var f = function (s, o) { return String(s || "").replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); };

  function run() {
    var N = window.NTD || {}, T = N.t || {};
    if (!N.loadStickers) return;
    var extra = [];
    try { extra = JSON.parse((root.querySelector("[data-extra-stickers]") || {}).textContent || "[]"); } catch (e) {}
    // the library with all of the shop's entries applied (new stickers, changed or hidden ones)
    var all = N.loadAll ? N.loadAll() : N.loadStickers().then(function (list) { return list.concat(extra); });
    all.then(function (list) {
      var hits = N.findStickers(list, q);
      if (!hits.length) return;
      box.querySelector("[data-stk-grid]").innerHTML = hits.slice(0, 24).map(function (s, i) {
        var href = N.builderLink("picks=" + encodeURIComponent(s.i) + "&q=" + encodeURIComponent(q));
        return '<a class="ntd-search__tile" href="' + esc(href) + '" style="--tint:' + tints[i % tints.length] + '">' +
          '<i><img src="' + esc(s.u || N.stickerImg(s.i)) + '" alt="" width="120" height="120"' + (i < 8 ? "" : ' loading="lazy"') + "></i>" +
          '<span lang="en" dir="ltr">' + esc(s.n) + "</span></a>";
      }).join("");
      var count = box.querySelector("[data-stk-count]");
      if (count) count.textContent = f(hits.length === 1 ? T.search_one : T.search_count, { n: hits.length.toLocaleString("en") });
      box.querySelector("[data-stk-all]").href = N.builderLink("q=" + encodeURIComponent(q));
      box.hidden = false;
      if (N.refreshMotion) N.refreshMotion();
    });
  }
  // ntd.js (the sticker helpers) runs after this deferred script; DOMContentLoaded comes after both
  if (window.NTD && window.NTD.loadStickers) run(); else doc.addEventListener("DOMContentLoaded", run);
})();
